import { getField, updateField } from 'vuex-map-fields';
import constants from '~/shared/constants';
import { getNewUniqueId } from '~/shared/utils';

// these fields need to exist to become reactive
const emptyPoi = {
  feature: {
    type: 'Feature',
    properties: {
      name: null,
      icon: null,
      _type: constants.FEATURE_TYPES.POI
    },
    geometry: null
  },
  id: null,
  levelId: null
};

const emptyState = {
  editedPoi: null,
  isNew: false,
  poiIcon: undefined,
  isIconEdited: false
};

const state = {
  ...emptyState
};

const actions = {
  async edit({ commit, rootGetters }, poiId) {
    const featuresByLevel = rootGetters['feature/featuresByLevel'];
    const editedLevelId = rootGetters['level/editedLevelId'];
    commit(
      'edit',
      featuresByLevel[editedLevelId].find((feature) => feature.id === poiId)
    );
  },

  addNew({ commit, rootGetters }, payload) {
    payload.levelId = rootGetters['level/editedLevelId'];
    payload.id = getNewUniqueId();
    commit('addNew', payload);
  },

  async save({ commit, dispatch, rootGetters }) {
    let operation = constants.OPERATIONS.FLOORPLAN.ADD_POI;
    if (state.isNew) {
      commit('feature/addFeature', state.editedPoi, { root: true });
    } else {
      operation = constants.OPERATIONS.FLOORPLAN.MODIFY_POI;
      commit('feature/editFeature', state.editedPoi, { root: true });
    }
    const editedLevelId = rootGetters['level/editedLevelId'];
    commit('feature/updateCurrentFeatures', editedLevelId, { root: true });
    commit('reset');
    dispatch('history/add', operation, { root: true });
    dispatch('alert/success', null, { root: true });
  },

  reset({ commit }) {
    commit('reset');
  }
};

const mutations = {
  reset(state) {
    Object.assign(state, emptyState);
  },
  addNew(state, payload) {
    state.editedPoi = {
      ...emptyPoi,
      id: payload.id,
      levelId: payload.levelId,
      feature: {
        ...emptyPoi.feature,
        properties: {
          ...emptyPoi.feature.properties,
          ...payload.properties,
          id: payload.id,
          levelId: payload.levelId
        },
        geometry: payload.geometry
      }
    };
    state.isNew = true;
  },

  edit(state, payload) {
    state.editedPoi = { ...emptyPoi, ...payload };
    state.isNew = false;
  },

  openPoiDialog(state, payload) {
    state.isIconEdited = true;
    state.poiIcon = payload.icon;
  },

  closePoiDialog(state) {
    state.isIconEdited = false;
    state.poiIcon = undefined;
  },

  updateField
};

const getters = {
  editedPoi: (state) => state.editedPoi,
  isNew: (state) => state.isNew,
  poiIcon: (state) => state.poiIcon,
  isIconEdited: (state) => state.isIconEdited,
  getField
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
